import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { HelloHeaderRandomGreeting } from "modules/ClientAccount/components/HelloHeader/HelloHeaderRandomGreeting"

export function HelloHeader() {
    const [{ userAccount }] = useClientContext()
    if (userAccount.kind !== "verified") return null
    return <HelloHeaderRandomGreeting name={userAccount.name} />
}
